import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { RefreshScheme } from '~auth/runtime'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": false,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/login",
    "logout": "/login",
    "home": "/",
    "callback": "/login"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/",
      "sameSite": "lax",
      "domain": ".fourwaves.com",
      "secure": true,
      "maxAge": 2592000
    }
  },
  "localStorage": false,
  "defaultStrategy": "local"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // local
  $auth.registerStrategy('local', new RefreshScheme($auth, {
  "token": {
    "property": "token",
    "maxAge": 86400,
    "global": true
  },
  "refreshToken": {
    "property": "refreshToken",
    "data": "refreshToken",
    "maxAge": 2592000
  },
  "user": {
    "property": false
  },
  "endpoints": {
    "login": {
      "url": "/api/auth/login",
      "method": "post",
      "propertyName": "token"
    },
    "refresh": {
      "url": "/api/auth/refresh",
      "method": "post"
    },
    "logout": {
      "url": "/api/auth/logout",
      "method": "post"
    },
    "user": {
      "url": "/api/account/settings",
      "method": "get",
      "propertyName": false
    }
  },
  "name": "local"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
